import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

interface LiveTvSecondaryIconPropsType {
    className?: string;
    onClick?: () => void;
}

export const LiveTvSecondaryIcon = observer(
    'LiveTvSecondaryIcon',
    ({ className, onClick }: LiveTvSecondaryIconPropsType): JSX.Element => {
        return (
            <SvgElement
                className={className}
                height='16'
                onClick={onClick}
                width='16'
                fill='none'
                viewBox='0 0 16 16'
                xmlns='http://www.w3.org/2000/svg'
            >
                <path
                    fill='#00ca72'
                    fillRule='evenodd'
                    d='M14.299 3.387a1.2 1.2 0 0 0-.851-.354H2.553q-.482 0-.851.354a1.16 1.16 0 0 0-.369.866v7.262q0 .482.369.837.37.354.85.354h10.895q.482 0 .85-.354.37-.355.37-.837V4.253q0-.511-.37-.866m-3.887 4.497-4.227-2.44v4.851z'
                    clipRule='evenodd'
                />
            </SvgElement>
        );
    }
);
